import React from 'react';
import { Navigate } from 'react-router-dom';

// Function to check if the user is authenticated
const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  return token !== null;
};

interface PrivateRouteProps {
  element: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  console.log(element,'element');
  console.log(isAuthenticated(),'isAuthenticated');

  
  return isAuthenticated() ? (
    <>{element}</>
  ) : (
    <Navigate to="/authentication/sign-in" />
  );
};

export default PrivateRoute;
